export default __webpack_public_path__ + "img/jtc/jtc1_1500.webp";